// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1yVXM","image":"Header_image__3_JqQ","name":"Header_name__2RCSg","info":"Header_info__1xjnl","infoRow":"Header_infoRow__3tdCh"};